export default __webpack_public_path__ + "img/0d3c7470a5fb0c8ad5cf56963ce000ff.svg";